import React from 'react';
import { PropTypes } from 'prop-types';
import InputFieldBaseHOC from '../InputFieldBase';

const PasswordInput = (props) => {
    let { propertyName, value, onBlur, onChange, isDisabled } = props;
    return (
        <input name={propertyName}
            type="password"
            value={value}
            disabled={isDisabled === true}
            autoComplete="current-password"
            onChange={(ev) => { onChange(propertyName, ev.target.value) }}
            onBlur={() => { onBlur(propertyName) }}
        />
    );
}

PasswordInput.propTypes = {
    propertyName: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    subtextKey: PropTypes.string,
    errorKey: PropTypes.string,
    extraErrorContent: PropTypes.node,
    isDisabled: PropTypes.bool,
    lang: PropTypes.string.isRequired
};


export default InputFieldBaseHOC(PasswordInput);
